import { fetchApi } from '@/lib/api';
import type { ActivityMinute } from '@shared/human-time';

/** People's time (T-102): the minutes this tab counted as active (worker/src/api/activity.ts). */
export function postActivity(minutes: ActivityMinute[], opts: { keepalive?: boolean } = {}) {
  return fetchApi<{ kept: number }>('/activity', {
    method: 'POST',
    body: JSON.stringify({ minutes }),
    // Still sent when the tab is closing.
    keepalive: opts.keepalive,
  });
}
